import NotificationType from './NotificationType';
import EventFormApproved from './types/EventFormApproved';
import ReimbursementBackupGenerated from './types/ReimbursementBackupGenerated';
import ReimbursementCoverSheetGenerated from './types/ReimbursementCoverSheetGenerated';
import ReimbursementRequestSigningAuthorityApproval from './types/ReimbursementRequestSigningAuthorityApproval';
import SubRequestResponseReceived from './types/SubRequestResponseReceived';
import UserImportComplete from './types/UserImportComplete';
import UserImportFailed from './types/UserImportFailed';

/**
 * Maps backend notification type strings to their frontend handler.
 *
 * Keys must match the `notification_type` declared in the notifier's
 * notification_methods block (app/notifiers/). That value is the single source
 * of truth — both the REST payload and the ActionCable broadcast send it as
 * `type`, so a live push and a page refresh resolve to the same handler.
 *
 * To register a new type, add an entry here keyed by that string.
 */
const REGISTRY = {
  event_form_approved: new EventFormApproved(),
  sub_request_response_received: new SubRequestResponseReceived(),
  reimbursement_request_signing_authority_approval: new ReimbursementRequestSigningAuthorityApproval(),
  reimbursement_backup_generated: new ReimbursementBackupGenerated(),
  reimbursement_cover_sheet_generated: new ReimbursementCoverSheetGenerated(),
  user_import_complete: new UserImportComplete(),
  user_import_failed: new UserImportFailed(),
};

const FALLBACK = new NotificationType();

/**
 * Look up the handler for a given notification type string.
 * Returns the base NotificationType (bell icon, no route) for unknown types.
 */
export function getNotificationType(type) {
  return REGISTRY[type] || FALLBACK;
}
